(function () {
  'use strict';

  angular.module('sempraWebapp').factory('userGroupActions', userGroupActionsFactory);

  /** @ngInject */
  function userGroupActionsFactory ($q, api, dispatcher, ActionTypesEnum, $translate) {
    return {
      getUserGroups: getUserGroups,
      getUserGroupById: getUserGroupById,
      createUserGroup: createUserGroup,
      updateUserGroup: updateUserGroup,
      deleteUserGroup: deleteUserGroup,
      getUsersForUserGroup: getUsersForUserGroup,
      addUserToUserGroup: addUserToUserGroup,
      removeUserFromUserGroup: removeUserFromUserGroup,
      getActiveUsersForUserGroup : getActiveUsersForUserGroup,
      getTemporalRulePercentage : getTemporalRulePercentage
    };

    function getUsersForUserGroup (groupId, page, pageSize, orderBy, order) {
      var deferred = $q.defer();

      api.getUsersForUserGroup(groupId, page, pageSize, orderBy, order).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getActiveUsersForUserGroup (groupId, page, pageSize, orderBy, order) {
      var deferred = $q.defer();
      // dispatcher.dispatch({type: ActionTypesEnum.SHOW_LOADER});

      api.getActiveUsersForUserGroup(groupId, page, pageSize, orderBy, order).then(function (data) {
        // dispatcher.dispatch({type: ActionTypesEnum.HIDE_LOADER});
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function removeUserFromUserGroup (membershipId) {
      var deferred = $q.defer();

      api.removeUserFromUserGroup(membershipId).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('DELETE_USER_FROM_GROUP_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function addUserToUserGroup (groupId, userId) {
      var deferred = $q.defer();
      api.addUserToUserGroup(groupId, userId).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('ADD_USER_TO_GROUP_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getUserGroups () {
      var deferred = $q.defer();
      // dispatcher.dispatch({type: ActionTypesEnum.SHOW_LOADER});

      api.getUserGroups().then(function (data) {
        // dispatcher.dispatch({type: ActionTypesEnum.HIDE_LOADER});
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getUserGroupById (groupId) {
      var deferred = $q.defer();

      api.getUserGroupById(groupId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getTemporalRulePercentage (temporalDeviceType) {
      var deferred = $q.defer();

      api.getTemporalRulePercentage (temporalDeviceType).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function createUserGroup (groupName) {
      var deferred = $q.defer();

      api.createUserGroup(groupName).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('CREATE_USER_GROUP_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function updateUserGroup (groupId, groupName) {
      var deferred = $q.defer();

      api.updateUserGroup(groupId, groupName).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('UPDATE_USER_GROUP_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function deleteUserGroup (groupId) {
      var deferred = $q.defer();
      
      api.deleteUserGroup(groupId).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('DETELE_USER_GROUP_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

  }
})();
